import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { TaskDescription } from '../components/TaskDescription.tsx';
import { TaskDescriptionParagraph } from '../components/TaskDescriptionParagraph.tsx';
import ShowMeButton from '../components/ShowMeButton.tsx';
import { SHARE_AND_COLLABORATE_TOUR_STEP_1_SPOTLIGHT_ID } from '../ui/spotlights/share-and-collaborate/constants.tsx';
import { useActions } from '../services/index.tsx';
import { messages } from './shareAndCollaborate.messages.tsx';
import { TASK_SHARE_AND_COLLABORATE } from './constants.tsx';
import type { TaskDefinition } from './types.tsx';

const Description = () => {
	const { formatMessage } = useIntl();
	const { setSpotlightStepId } = useActions();
	return (
		<TaskDescription>
			<TaskDescriptionParagraph>{formatMessage(messages.description)}</TaskDescriptionParagraph>
			<ShowMeButton
				onClick={() => setSpotlightStepId(SHARE_AND_COLLABORATE_TOUR_STEP_1_SPOTLIGHT_ID)}
			/>
		</TaskDescription>
	);
};

export const shareAndCollaborate = {
	id: TASK_SHARE_AND_COLLABORATE,
	title: messages.title,
	description: <Description />,
} satisfies TaskDefinition;
